import React from 'react';
import { ChipSelectorQuestion } from './ChipSelectorQuestion';
import { TOPIC_EXAMPLES } from '../../onboardingExamples';

interface TopicsQuestionProps {
  selectedValue: string;
  customValue: string;
  onSelectedChange: (value: string) => void;
  onCustomChange: (value: string) => void;
}

export const TopicsQuestion: React.FC<TopicsQuestionProps> = ({
  selectedValue,
  customValue,
  onSelectedChange,
  onCustomChange
}) => {
  return (
    <ChipSelectorQuestion
      label="Which topics would you like to stay informed about?"
      description="Choose from our suggestions or add your own topics—be as broad or specific as you'd like."
      chips={TOPIC_EXAMPLES}
      selectedValue={selectedValue}
      customValue={customValue}
      onSelectedChange={onSelectedChange}
      onCustomChange={onCustomChange}
      placeholder="CRISPR patent disputes, FDA approvals for psychedelics, lithium mining in Nevada, TSMC Arizona fab construction, Waymo safety incidents, copyright law for AI training data, NASA Europa mission, GLP-1 drug development, Starship launch timelines, homesteading in northern Arizona…"
    />
  );
};
